export default "__VITE_ASSET__30b7527a__"